import React from "react";
import { Link, withRouter } from "react-router-dom";
import { analytics } from "../../../analytics";

const SignupEmail = props => {
  const analyticsTracking = () => {
    analytics("registration_email_mail_sent");
  };
  return (
    <div>
      <div className="text-center mt50">
        {props.message && <p className="error">{props.message}</p>}
        <h3>Check your email</h3>
        <p className="subHeading">
          Click the button in the email to confirm your account,
        </p>
        <p className="subHeading error">
          Remember to check your spam/junk email, otherwise contact
          support@ausbiz.com.au for issues.
        </p>
      </div>

      <div className="text-center mar-popup-image">
        <img src="/assets/svg/group.svg" alt="Email_sent" />
      </div>

      <div className="mt75">
        <Link
          to="/signin"
          className="btn continue active"
          onClick={() => analyticsTracking()}
        >
          Continue
        </Link>
        <p className="subheading text-center">
          Didn’t receive an email?&nbsp;&nbsp;
          <span className="clickable" onClick={() => props.sucessHandler()}>
            Resend
          </span>
        </p>
      </div>
    </div>
  );
};

export default withRouter(SignupEmail);
